import { EnumSchema } from '../metadata-schema';

export const UitstroomniveauVSO: EnumSchema = {
	"type": "string",
	"title": "UitstroomniveauVSO",
	"enum": [
		"Vavo",
		"MBO niveau 1",
		"MBO niveau 2",
		"MBO niveau 3",
		"MBO niveau 3/4",
		"MBO niveau 4",
		"HBO",
		"Universiteit",
		"HBO/Universiteit",
		"Reguliere arbeidsplaats",
		"Sociale werkvoorziening",
		"Beschut werk/beschermde werkomgeving",
		"Arbeidstrainingscentrum",
		"Dagbesteding belevingsgericht",
		"Dagbesteding activerend",
		"Dagbesteding arbeidsmatig",
		"Vrijwilligerswerk"
	]
};
